import {
  SET_DIALOG_EDIT_DOOR_ACCESS_USER,
  CLEAR_DIALOG_EDIT_DOOR_ACCESS_USER,
  LOGOUT_RESPONSE,
} from '../constants'

const initialState = {
  accessId: null,
  name: '',
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_DIALOG_EDIT_DOOR_ACCESS_USER:
      return {
        accessId: action.accessId,
        name: (action.name || '') !== '' ? action.name : state.name,
      }

    case CLEAR_DIALOG_EDIT_DOOR_ACCESS_USER:
    case LOGOUT_RESPONSE:
      return initialState

    default:
      return state
  }
}
